<template>
  <div>
    <v-row v-if="groupItems.length === 0" justify="center" align="center">
      <v-col cols="1">
        <v-btn
            tile
            color="primary"
            prepend-icon="mdi-plus"
            outlined
            @click="addGroup()"
        >
          {{ $t("Add") }}
        </v-btn>
      </v-col>
    </v-row>
    <div v-for="(item, index) in groupItems" :key="item.uuid">
      <v-row>
        <v-col cols="auto" align-self="center">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                tile
                large
                color="error"
                icon
                @click="removeGroup(item.uuid)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("Remove") }}</span>
          </v-tooltip>
        </v-col>
        <v-col align-self="center">
          <v-autocomplete
            v-model="item.fieldTitle"
            v-bind:label="$t('GroupBy')"
            :items="getFieldTitles(item)"
            :error-messages="fieldTitleErrors(index)"
          ></v-autocomplete>
        </v-col>
        <v-col align-self="center">
          <v-autocomplete
            v-model="item.sumFields"
            :items="getFieldTitlesForSummarize(true)"
            v-bind:label="$t('Sum')"
            multiple
          ></v-autocomplete>
        </v-col>
        <v-col align-self="center">
          <v-autocomplete
            v-model="item.maxFields"
            :items="getFieldTitlesForSummarize()"
            v-bind:label="$t('MaxValue')"
            multiple
          ></v-autocomplete>
        </v-col>
        <v-col align-self="center">
          <v-autocomplete
            v-model="item.minFields"
            :items="getFieldTitlesForSummarize()"
            v-bind:label="$t('MinValue')"
            multiple
          ></v-autocomplete>
        </v-col>
        <v-col align-self="center">
          <v-autocomplete
            v-model="item.avgFields"
            :items="getFieldTitlesForSummarize(true)"
            v-bind:label="$t('AvgValue')"
            multiple
          ></v-autocomplete>
        </v-col>
        <v-col align-self="center" v-if="editingBasketId === null">
          <v-switch
            v-model="item.summarizeOnlySelectedDocuments"
            :label="$t('SummarizeOnlySelectedDocuments')"
          ></v-switch>
        </v-col>
        <v-col cols="auto" align-self="center" class="ml-auto">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                v-show="showAddButton"
                v-on="on"
                tile
                large
                color="primary"
                icon
                @click="addGroup()"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("Add") }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-subheader v-if="!isLastGroup(item.uuid)"
        >--- {{ $t("ThenBy") }} ---</v-subheader
      >
    </div>
  </div>
</template>
<script>
import GroupItem from "@/ecm/models/search/GroupItem";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import FieldType from "@/ecm/variables/FieldType";
import Utils from "@/ecm/common/Utils.js";
import BasketService from "@/services/BasketService";

export default {
  name: "GroupModal",
  props: {
    fieldList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    fieldList: function (newVal, oldVal) {
      this.setGroupObj(this.groupStr);
    },
  },
  created() {
    this.addGroup();
  },
  data() {
    return {
      modal: {
        title: this.$t("ToGroup"),
        key: "groupModal",
      },
      open: false,
      groupItems: [],
      groupStr: "",
      editingBasketId: null,
    };
  },
  mixins: [validationMixin],
  validations: {
    groupItems: {
      $each: {
        fieldTitle: { required },
      },
    },
  },
  computed: {
    modalInstance() {
      return this.$refs[this.modal.key];
    },
    showAddButton() {
      var fieldTitles = Array.from(
        new Set(this.fieldList.filter((f) => f.IsVisible).map((f) => f.Title))
      );
      return this.groupItems.length < fieldTitles.length;
    },
  },
  methods: {
    getGroupStr() {
      let group = "";
      //Validates if the group configuration is not empty
      if(this.groupItems.length == 0 || (this.groupItems.length == 1 && this.getFieldCode(this.groupItems[0].fieldTitle) == "")){
        return null;
      }
      else
      {
        this.groupItems.forEach((item) => {
          group += "FIELD:" + this.getFieldCode(item.fieldTitle);
          group += "SUMFIELDS:" + this.getFieldsCode(item.sumFields);
          group += "MAXFIELDS:" + this.getFieldsCode(item.maxFields);
          group += "MINFIELDS:" + this.getFieldsCode(item.minFields);
          group += "AVGFIELDS:" + this.getFieldsCode(item.avgFields);
          group +=
            "SUMONLYSELECTED:" +
            (item.summarizeOnlySelectedDocuments ? "T" : "F");
          group += ";";
        });
        return group;
      }
    },
    getFieldCode(fieldTitle) {
      let fieldCode = "";
      this.fieldList.forEach((field) => {
        if (field.Title == fieldTitle) {
          fieldCode = field.Code;
        }
      });
      return fieldCode;
    },
    getFieldsCode(fieldTitles) {
      let fieldsCodes = [];
      fieldTitles.forEach((title) => {
        this.fieldList.forEach((field) => {
          if (
            field.Title == title &&
            !fieldsCodes.some((code) => code == field.Code)
          ) {
            fieldsCodes.push(field.Code);
          }
        });
      });
      return fieldsCodes;
    },
    getFieldTitle(fieldCode) {
      let fieldTitle = "";
      this.fieldList.forEach((field) => {
        if (field.Code == fieldCode) {
          fieldTitle = field.Title;
        }
      });
      return fieldTitle;
    },
    getFieldsTitle(fieldCode) {
      let fieldsTitle = [];
      fieldCode.forEach((code) => {
        this.fieldList.forEach((field) => {
          if (field.Code == code && !fieldsTitle.includes(field.Title)) {
            fieldsTitle.push(field.Title);
          }
        });
      });
      return fieldsTitle;
    },
    groupItemTitlesToCodes(item) {
      item.fieldTitle = this.getFieldCode(item.fieldTitle);
      item.sumFields = this.getFieldsCode(item.sumFields);
      item.maxFields = this.getFieldsCode(item.maxFields);
      item.minFields = this.getFieldsCode(item.minFields);
      item.avgFields = this.getFieldsCode(item.avgFields);
      return item;
    },
    setGroupObj(groupStr) {
      if (groupStr != "") {
        this.groupStr = groupStr;
      }
      else
      {
        this.groupStr = "";
      }
      let groupItems = groupStr.split(";");
      this.groupItems = [];
      groupItems.forEach((item) => {
        let groupItem = new GroupItem();
        const match = item.match(/FIELD:(.*?)SUMFIELDS:(.*)MAXFIELDS:(.*?)MINFIELDS:(.*?)AVGFIELDS:(.*?)SUMONLYSELECTED:(.*?)/);
        if (match) {
          groupItem.fieldTitle = this.getFieldTitle(match[1]);
          groupItem.sumFields = this.getFieldsTitle(match[2].split(","));
          groupItem.maxFields = this.getFieldsTitle(match[3].split(","));
          groupItem.minFields = this.getFieldsTitle(match[4].split(","));
          groupItem.avgFields = this.getFieldsTitle(match[5].split(","));
          groupItem.summarizeOnlySelectedDocuments =
            item.charAt(item.length - 1) === "T" ? true : false;
          this.groupItems.push(groupItem);
        }
      });
      if (this.groupItems.length === 0) {
        this.addGroup();
      }
    },
    loadGroupItems(groupItems) {
      this.groupItems = groupItems;
    },
    getFieldTitles(item) {
      if (this.fieldList || this.fieldList.length > 0) {
        let fieldTitles = Array.from(
          new Set(this.fieldList.filter((f) => f.IsVisible).map((f) => f.Title))
        );
        fieldTitles = fieldTitles.filter(
          (f) =>
            !this.groupItems.some(
              (gi) => gi.fieldTitle == f && gi.uuid != item.uuid
            )
        );
        return fieldTitles;
      } else {
        return [];
      }
    },
    getFieldTitlesForSummarize(onlyNumeric) {
      if (this.fieldList || this.fieldList.length > 0) {
        return Array.from(
          new Set(
            this.fieldList
              .filter(
                (f) =>
                  (f.IsVisible &&
                    f.Type == FieldType.DateTime &&
                    !onlyNumeric) ||
                  f.Type == FieldType.Numeric
              )
              .map((f) => f.Title)
          )
        );
      } else {
        return [];
      }
    },
    fieldTitleErrors(index) {
      const errors = [];
      if (!this.$v.groupItems.$each[index].fieldTitle.$dirty) return errors;
      !this.$v.groupItems.$each[index].fieldTitle.required &&
        errors.push(this.$t("RequiredField"));
      return errors;
    },
    addGroup() {
      this.groupItems.push(new GroupItem());
    },
    removeGroup(uuid) {
      this.groupItems = this.groupItems.filter((item) => item.uuid !== uuid);
    },
    onAccept() {
      if (
        this.groupItems.length === 1 &&
        this.groupItems[0].fieldTitle === ""
      ) {
        if (this.editingBasketId) {
          this.groupItems.forEach((item) => {
            item = this.groupItemTitlesToCodes(item);
          });
          this.$emit("on-save", {
            GroupSettings: this.groupItems,
            BasketId: this.editingBasketId,
          });
        } else {
          this.$emit("on-grouped", []);
        }
      } else {
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }
        if (this.editingBasketId) {
          this.groupItems.forEach((item) => {
            item = this.groupItemTitlesToCodes(item);
          });
          let clonedForBasket = this.groupItems.map((item) => {
            return Utils.object.clone(new GroupItem(), item);
          });
          this.$emit("on-save", {
            GroupSettings: clonedForBasket,
            BasketId: this.editingBasketId,
          });
        } else {
          let cloned = this.groupItems.map((item) => {
            return Utils.object.clone(new GroupItem(), item);
          });
          this.$emit("on-grouped", cloned);
        }
      }
    },
    load(lastGroupOptions, editingBasketId) {
      this.editingBasketId = editingBasketId || null;
      if (this.editingBasketId) {
        BasketService.getGroupSettingsForBasket(this.editingBasketId).then(
          (result) => {
            this.groupItems = [];
            result.forEach((t) => {
              t.FieldTitle = this.getFieldTitle(t.FieldTitle);
              t.SumFields = this.getFieldsTitle(t.SumFields);
              t.MaxFields = this.getFieldsTitle(t.MaxFields);
              t.MinFields = this.getFieldsTitle(t.MinFields);
              t.AvgFields = this.getFieldsTitle(t.AvgFields);
              this.groupItems.push(new GroupItem(t));
            });
            if (this.groupItems.length === 0) {
              this.addGroup();
            }
          }
        );
      }

      this.$v.$reset();

      if (lastGroupOptions) {
        this.groupItems = lastGroupOptions;
      } else if (this.groupItems.length === 0) {
        this.addGroup();
      }
    },
    reset() {
      this.setGroupObj("");
    },
    isLastGroup(uuid) {
      if (this.groupItems.length <= 1) return true;
      return this.groupItems[this.groupItems.length - 1].uuid === uuid;
    },
  },
};
</script>